import React from 'react';

const SearchMenu = ({}) => {
  return (<></>);
};

export default SearchMenu;